export default "__VITE_ASSET__BRyafzBD__"